/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessMedicationFileDto
 */
export interface ProcessMedicationFileDto {
    /**
     * Firebase Storage file path or URL
     * @type {string}
     * @memberof ProcessMedicationFileDto
     */
    filePath: string;
}

/**
 * Check if a given object implements the ProcessMedicationFileDto interface.
 */
export function instanceOfProcessMedicationFileDto(value: object): value is ProcessMedicationFileDto {
    if (!('filePath' in value) || value['filePath'] === undefined) return false;
    return true;
}

export function ProcessMedicationFileDtoFromJSON(json: any): ProcessMedicationFileDto {
    return ProcessMedicationFileDtoFromJSONTyped(json, false);
}

export function ProcessMedicationFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessMedicationFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filePath': json['filePath'],
    };
}

export function ProcessMedicationFileDtoToJSON(json: any): ProcessMedicationFileDto {
    return ProcessMedicationFileDtoToJSONTyped(json, false);
}

export function ProcessMedicationFileDtoToJSONTyped(value?: ProcessMedicationFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filePath': value['filePath'],
    };
}

